/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { ID } from '@gh/common-shared-data';

export interface FileListItem {
  id: ID;
  name: string;
  type: string;
  url: string;
  ownerId?: string;
}

export abstract class FilePicker {
  abstract registerOnSelected(onSelected: (files: FileListItem[]) => void): void;
}
